/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1PersonIdSchoolEducationsSchooleducationid202,
  PutApiV1PersonIdSchoolEducationsSchooleducationid400,
  PutApiV1PersonIdSchoolEducationsSchooleducationid401,
  PutApiV1PersonIdSchoolEducationsSchooleducationid404,
  PutApiV1PersonIdSchoolEducationsSchooleducationid500,
  PutApiV1PersonIdSchoolEducationsSchooleducationidMutationRequest,
  PutApiV1PersonIdSchoolEducationsSchooleducationidMutationResponse,
  PutApiV1PersonIdSchoolEducationsSchooleducationidPathParams,
} from "../../types/personStudentController/PutApiV1PersonIdSchoolEducationsSchooleducationid.ts";
import { schoolEducationDetailViewModelSchema } from "../schoolEducationDetailViewModelSchema.ts";
import { updateSchoolEducationViewModelSchema } from "../updateSchoolEducationViewModelSchema.ts";

export const putApiV1PersonIdSchoolEducationsSchooleducationidPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    schoolEducationId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1PersonIdSchoolEducationsSchooleducationidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1PersonIdSchoolEducationsSchooleducationid202Schema =
  z.lazy(
    () => schoolEducationDetailViewModelSchema,
  ) as unknown as ToZod<PutApiV1PersonIdSchoolEducationsSchooleducationid202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1PersonIdSchoolEducationsSchooleducationid400Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdSchoolEducationsSchooleducationid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1PersonIdSchoolEducationsSchooleducationid401Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdSchoolEducationsSchooleducationid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1PersonIdSchoolEducationsSchooleducationid404Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdSchoolEducationsSchooleducationid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1PersonIdSchoolEducationsSchooleducationid500Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdSchoolEducationsSchooleducationid500>;

export const putApiV1PersonIdSchoolEducationsSchooleducationidMutationRequestSchema =
  z.lazy(
    () => updateSchoolEducationViewModelSchema,
  ) as unknown as ToZod<PutApiV1PersonIdSchoolEducationsSchooleducationidMutationRequest>;

export const putApiV1PersonIdSchoolEducationsSchooleducationidMutationResponseSchema =
  z.lazy(
    () => putApiV1PersonIdSchoolEducationsSchooleducationid202Schema,
  ) as unknown as ToZod<PutApiV1PersonIdSchoolEducationsSchooleducationidMutationResponse>;
